import InputAdornment from '@mui/material/InputAdornment';
import CallMissedOutgoingIcon from '@mui/icons-material/CallMissedOutgoing';
import { Theme, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import { BooleanField, BooleanInput, Button, Create, Datagrid, Edit, EditButton, FormDataConsumer, FormTab, List, SelectInput, Show, ShowActions, SimpleList, SimpleShowLayout, TabbedForm, TextField, TextInput, required, usePermissions, useResourceDefinition } from 'react-admin';
import { useParams } from 'react-router-dom';
import DateFnsField from 'utils/react-admin/DateFnsField';
import GridWrapper from 'utils/react-admin/GridWrapper';
import FileManagerModalInput from 'utils/react-admin/inputs/FileManagerModalInput';
// import { GrapesjsInputButton } from 'utils/react-admin/inputs/GrapesjsInput';
import { BASE_URL } from 'utils/api';
import ApiKeyInput from 'utils/react-admin/ApiKeyInput';
import XlsHtmlExporter from 'utils/react-admin/exporters/XlsHtml';
import DateRangeFilterInput from 'utils/react-admin/filters/DateRangeFilterInput';
import { Permissions } from '../../ra-php-crud-api-auth';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton from '@mui/material/IconButton';
export const CHOICES_OG_REDIRECT_MODE = [
  { id: 'link_to_file', name: 'Link to file', },
  { id: 'facebook_redirect', name: 'Facebook Redirect', },
];
// const RESOURCE_FIELDS = {}
const ResourceFilters = [
  <TextInput source="search" alwaysOn />,
  <BooleanInput source="is_public" fullWidth />,
  <SelectInput source="mode" fullWidth choices={CHOICES_OG_REDIRECT_MODE} />,
  <TextInput source="alias" fullWidth />,
  <TextInput source="og_title" fullWidth />,
  <TextInput source="og_description" fullWidth />,
  <TextInput source="url" fullWidth />,
  <DateRangeFilterInput source="created" fullWidth />,
  <TextInput source="createdBy" fullWidth />,
  <DateRangeFilterInput source="updated" fullWidth />,
  <TextInput source="updatedBy" fullWidth />,
];

export const ResourceList = () => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <List filters={ResourceFilters} sort={{ field: 'created', order: 'DESC' }} exporter={XlsHtmlExporter}>
      {isSmall ? (
        <SimpleList linkType="edit"
          primaryText={(record: any) => `${record.title_tc} (#${record.id})`}
        ></SimpleList>)
        : (
          <Datagrid>
            <TextField source="id" />
            <BooleanField source="is_public" fullWidth />
            <TextField source="alias" fullWidth />
            <TextField source="og_title" fullWidth />
            <TextField source="og_description" fullWidth />
            <TextField source="url" fullWidth />
            <DateFnsField source="created" />
            <DateFnsField source="updated" />
            {/* <ShowButton /> */}
            <EditButton />
          </Datagrid>)
      }
    </List>
  )
};

export const ResourceShow = () => {
  const { isLoading, permissions } = usePermissions<Permissions>();
  const { hasEdit } = useResourceDefinition();

  if (isLoading || undefined === permissions) { return (<>Loading</>); }

  return (
    <Show actions={hasEdit ? <ShowActions /> : <></>}>
      <SimpleShowLayout>
        <TextField source="id" />
        <BooleanField source="is_public" fullWidth />
        <TextField source="alias" fullWidth />
        <TextField source="og_title" fullWidth />
        <TextField source="og_description" fullWidth />
        <TextField source="url" fullWidth />
        <DateFnsField source="created" />
        <DateFnsField source="updated" />
      </SimpleShowLayout>
    </Show>
  )
};

const transform = (data: any) => {
  console.log('transform', data);
  data.og_image_fm = ('string' === typeof data.og_image_fm) ? data.og_image_fm : (null === data.og_image_fm ? null : JSON.stringify(data.og_image_fm));;;
  data.file_fm = ('string' === typeof data.file_fm) ? data.file_fm : (null === data.file_fm ? null : JSON.stringify(data.file_fm));;;

  return data;
};

const validateIsPublic: any[] = [required()];
const validateMode: any[] = [required()];
const validateUrl: any[] = [required()];
const validateOgTitle: any[] = [];
const validateOgDescription: any[] = [];
const validateAlias: any[] = [required()];

export const ResourceForm = ({ isEdit }: { isEdit?: boolean }) => {
  // const { getMany } = useDataProvider();
  const { ref, ref_id, ref_default_values } = useParams();
  // const redirect = ref_id ? `/${ref}/${ref_id}` : undefined;
  const defaultValueRefId = ref_id ? { [`${ref}_id`]: ref_id } : {};
  const refDefaultValues = ref_default_values ? JSON.parse(ref_default_values as string) : {};

  return (
    <TabbedForm
      defaultValues={{ ...defaultValueRefId, ...refDefaultValues }}
    >
      {/* redirect={redirect} */}
      <FormTab label="ra.page.general">
        <GridWrapper>
          <Grid item xs={2}><BooleanInput source="is_public" fullWidth validate={validateIsPublic} /></Grid>
          <Grid item xs={4}><SelectInput source="mode" fullWidth choices={CHOICES_OG_REDIRECT_MODE} validate={validateMode} /></Grid>
          <Grid item xs={6}>
            <ApiKeyInput source="alias" fullWidth validate={validateAlias} readOnly={false}
              inputProps={{
                readOnly: false,
                endAdornment: <InputAdornment position="end"><FormDataConsumer>{({ formData }) => <IconButton  onClick={() => { navigator.clipboard.writeText(`${process.env.REACT_APP_API_URL}og-redirect/${formData.alias}`); alert("Link Copied!"); }}><ContentCopyIcon /></IconButton>}</FormDataConsumer></InputAdornment>
              }}
            />
          </Grid>
          <Grid item xs={6}><TextInput source="og_title" fullWidth validate={validateOgTitle} /></Grid>
          <Grid item xs={6}><TextInput source="og_description" fullWidth validate={validateOgDescription} /></Grid>
          <Grid item xs={12}><FileManagerModalInput source="og_image_fm" mode="image" /></Grid>
          <FormDataConsumer>{({ formData }) => {
            if ('link_to_file' === formData.mode) {
              return <Grid item xs={12}><FileManagerModalInput source="file_fm" mode="file" /></Grid>
            } else if ('facebook_redirect' === formData.mode) {
              return <Grid item xs={12}><TextInput source="url" fullWidth validate={validateUrl} /></Grid>
            }
          }}</FormDataConsumer>
        </GridWrapper>
      </FormTab>
    </TabbedForm>
  )
}

export const ResourceCreate = () => {
  return (
    <Create mutationMode="pessimistic" transform={transform}>
      <ResourceForm />
    </Create>
  )
};

export const ResourceEdit = () => {
  return (
    <Edit mutationMode="pessimistic" transform={transform}>
      <ResourceForm isEdit={true} />
    </Edit>
  )
};

const Resource = {
  list: ResourceList,
  edit: ResourceEdit,
  create: ResourceCreate,
  // show: ResourceShow,
  icon: CallMissedOutgoingIcon,
}

export default Resource;
